import avax from './avax.svg'
import bnb from './bnb.svg'
import eos from './eos.svg'
import eth from './eth.svg'
import pol from './polygon.svg'
import wax from './wax.svg'

export default { avax, bnb, eos, eth, pol, wax }
